// extracted by mini-css-extract-plugin
export default {"createTransactionFormCenter":"CreateTransactionPage_createTransactionFormCenter__PLFBb"};